export default function contentTypeName(contentType) {
  switch (contentType) {
    case `drill`:
      return `practice`;

    case `pitchdiagram`:
      return `diagram`;

    default:
      return contentType;
  }
}

export function contentTypePlural(contentType) {
  switch (contentType) {
    case `practice`:
    case `drill`:
    case `session`:
    case `guide`:
    case `pitchdiagram`:
    case `diagram`:
    case `interview`:
    case `user`:
    case `club`:
    case `team`:
      return `${contentType}s`;

    default:
      return contentType;
  }
}



// WEBPACK FOOTER //
// ./library/app/utils/contentTypeName.js